import { InterfaceIcon } from '@helpers/icons';
import Button from '@stories/Components/Buttons/Button/Button';
import { AnimatePresence } from 'framer-motion';
import * as React from 'react';
import ErrorSummary from './ErrorSummary';
import S from './Form.styles';
const Form = ({ buttonType, children, confirmationMessage, errors = [], showSubmit = true, status = 'initial', submitLabel, onSubmit, showConfirmation, ...props }) => {
    const refForm = React.useRef(null);
    const variants = {
        initial: { y: `-20px`, scale: 0.9, opacity: 0 },
        animate: {
            y: `0px`,
            scale: 1,
            opacity: 1,
        },
        exit: { y: `-20px`, scale: 0.9, opacity: 0 },
    };
    return (React.createElement(S.Form, { ref: refForm, onSubmit: onSubmit, ...props },
        React.createElement(AnimatePresence, null,
            status === 'error' && errors.length > 0 && (React.createElement(ErrorSummary, { key: `${props.id}-errors`, errors: errors, variants: variants })),
            (status === 'fulfilled' || showConfirmation) && confirmationMessage && (React.createElement(S.ConfirmationMessage, { key: `${props.id}-confirmation`, dangerouslySetInnerHTML: { __html: confirmationMessage }, ...variants }))),
        status !== 'fulfilled' && children,
        status !== 'fulfilled' && showSubmit && (React.createElement(S.SubmitWrapper, null,
            React.createElement(Button, { buttonType: buttonType ? buttonType : 'primary', disabled: status === 'pending', type: "submit", icon: status === 'pending' ? InterfaceIcon.Loader : undefined },
                React.createElement("span", { dangerouslySetInnerHTML: { __html: submitLabel } }))))));
};
export default Form;
